import React, { Component } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/styles";
import styles from "./assets/customSelectStyle.js";
import { connect } from "react-redux";
import { setProduct } from "../../store/actions";
import { loadVariants } from "../../store/actions/store";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  getDiscountedPrice,
  getProductDiscountAmount,
} from "../../Helpers/promotions";
import { getProductInventory } from "../../store/reducers/store.js";
import { getCurrencyIso } from "../../Helpers/currencyConverter";

class ProductVariants extends Component {
  state = {
    filteredChildren: [],
    originalVariationsDictionary: {},
    lastKey: "",

    numberOfSelectedItems: 0,
    selectedVariants: {},

    editing: false,
  };

  handleChange = (e) => {
    e.preventDefault();
    if (!this.state[[e.target.name]] && e.target.value != -1) {
      let newSelectedVariants = this.state.selectedVariants;
      newSelectedVariants[[e.target.name]] = e.target.value;
      if (this.props.current_product?.variant_values?.length === 1)
        this.setState({ editing: false });
      this.setState({
        numberOfSelectedItems: this.state.numberOfSelectedItems + 1,
        selectedVariants: newSelectedVariants,
      });
    } else if (e.target.value == -1) {
      let newSelectedVariants = this.state.selectedVariants;
      if (newSelectedVariants[[e.target.name]]) {
        delete newSelectedVariants[[e.target.name]];
        this.setState({
          numberOfSelectedItems: this.state.numberOfSelectedItems - 1,
          selectedVariants: newSelectedVariants,
        });
      }
    } else {
      let newSelectedVariants = this.state.selectedVariants;
      newSelectedVariants[[e.target.name]] = e.target.value;
      this.setState({
        selectedVariants: newSelectedVariants,
        editing: false,
      });
    }

    this.setState({
      [e.target.name]: e.target.value,
      lastKey: e.target.name,
    });

    this.filterChildren();
  };

  handleChangeGrid = (key, value) => {
    if (!this.state[[key]] && value != -1) {
      let newSelectedVariants = this.state.selectedVariants;
      newSelectedVariants[[key]] = value;
      if (this.props.current_product?.variant_values?.length === 1)
        this.setState({ editing: false });
      this.setState({
        numberOfSelectedItems: this.state.numberOfSelectedItems + 1,
        selectedVariants: newSelectedVariants,
      });
    } else if (value == -1) {
      let newSelectedVariants = this.state.selectedVariants;
      if (newSelectedVariants[[key]]) {
        delete newSelectedVariants[[key]];
        this.setState({
          numberOfSelectedItems: this.state.numberOfSelectedItems - 1,
          selectedVariants: newSelectedVariants,
        });
      }
    } else {
      let newSelectedVariants = this.state.selectedVariants;
      newSelectedVariants[[key]] = value;
      this.setState({
        selectedVariants: newSelectedVariants,
        editing: false,
      });
    }

    this.setState({
      [key]: value,
      lastKey: key,
    });

    this.filterChildren();
  };

  resetVariants = (e) => {
    Object.keys(this.state.originalVariationsDictionary).forEach((ke) =>
      this.setState({ [ke]: -1 })
    );

    this.setState({
      filteredChildren: [],
      lastKey: "",

      numberOfSelectedItems: 1,
    });
    if (e) {
      this.setState({
        selectedVariants: { [e.target.name]: e.target.value },
        [e.target.name]: e.target.value,
      });
      this.filterChildren(e);
    } else {
      this.filterChildren();
    }
  };

  resetVariantsGrid = (key, value) => {
    Object.keys(this.state.originalVariationsDictionary).forEach((ke) =>
      this.setState({ [ke]: -1 })
    );

    this.setState({
      filteredChildren: [],
      lastKey: "",

      numberOfSelectedItems: 1,
    });

    this.setState({
      selectedVariants: { [key]: value },
      [key]: value,
    });
    this.filterChildrenGrid(key, value);
  };

  findParent = () => {
    try {
      let parentProduct = this.props.store.categories
        .find((cat) => cat.id == this.props.current_product.category_id)
        .products.find((prod) => prod.id === this.props.current_product.parent);

      return parentProduct;
    } catch {
      return this.props.current_product;
    }
  };
  filterChildren = (e) => {
    const filteredChildren = [];
    let childVariantValues = [];
    const language = this.props.language;
    let current_product = this.props.current_product;
    if (current_product.variant_values) current_product = this.findParent();

    if (!Object.keys(this.state.selectedVariants).length) {
      this.setState({ filteredChildren: current_product.children });
      return;
    }
    for (let j = 0; j < current_product.children.length; j++) {
      current_product.children[j].variant_values.forEach((value) => {
        childVariantValues.push(
          language == "english" ? value.variant_value : value.variant_value_ar
        );
      });
      let temp = !e
        ? this.state.selectedVariants
        : { [e.target.name]: e.target.value };
      if (
        Object.keys(temp).every(
          (key) => childVariantValues.indexOf(temp[key]) > -1
        )
      )
        filteredChildren.push(current_product.children[j]);
      childVariantValues = [];
    }

    this.setState({
      filteredChildren: filteredChildren,
    });
  };

  filterChildrenGrid = (key, value) => {
    const filteredChildren = [];
    let childVariantValues = [];
    const language = this.props.language;
    let current_product = this.props.current_product;
    if (current_product.variant_values) current_product = this.findParent();

    if (!Object.keys(this.state.selectedVariants).length) {
      this.setState({ filteredChildren: current_product.children });
      return;
    }
    for (let j = 0; j < current_product.children.length; j++) {
      current_product.children[j].variant_values.forEach((value) => {
        childVariantValues.push(
          language == "english" ? value.variant_value : value.variant_value_ar
        );
      });
      let temp = { [key]: value };
      if (
        Object.keys(temp).every(
          (key) => childVariantValues.indexOf(temp[key]) > -1
        )
      )
        filteredChildren.push(current_product.children[j]);
      childVariantValues = [];
    }

    this.setState({
      filteredChildren: filteredChildren,
    });
  };
  componentDidUpdate = (prevProps) => {
    if (this.props.language !== prevProps.language) {
      this.setState({
        filteredChildren: [],
        originalVariationsDictionary: {},
        lastKey: "",

        numberOfSelectedItems: 0,
        selectedVariants: {},

        editing: false,
      });
    }
  };
  // componentDidMount = () => {
  //   if (
  //     this.props.current_product.has_variants &&
  //     !this.props.current_product.children?.length
  //   ) {
  //     this.props.loadVariants(this.props.current_product.id);
  //   }
  // };
  handleVariantPriceDiscount = (current_product) => {
    const { usedComponents,settings,language } = this.props;
    let currency = getCurrencyIso(settings,language);

    // if (["SAR","AED"].includes(this.props.settings?.currency_iso)) {
    //   currency = getCurrencyIso(current_product);
    // }
    const discountAmount = getProductDiscountAmount(
      current_product,
      this.props.coupon,
      this.props.promotions,
      this.props.store.smart_promos
    );
    const real_price = getDiscountedPrice(
      current_product?.price,
      discountAmount,
      null,
      null
    );
    let checkForInventoryMessage = "";
    if (
      ["composite", "stocked"].includes(current_product?.type_of_product) &&
      getProductInventory(current_product, usedComponents) <
        current_product.min_addable_quantity
    ) {
      const preorderingMode =
        current_product.allow_preordering &&
        current_product.preorder_inventory > 0;
      checkForInventoryMessage = preorderingMode
        ? this.props.language == "english"
          ? " - Pre-order"
          : "- طلب مسبق"
        : this.props.language === "english"
        ? " - Out of Stock"
        : " - غير متوفر";
    }

    return `(${real_price.toFixed(
      this.props.settings.currency_decimals
    )} ${currency}) ${checkForInventoryMessage}`;
  };
  handleVariantPriceDisplay = (vari, priceVariantDictionary) => {
    for (const key in this.state.selectedVariants) {
      if (this.state.selectedVariants.hasOwnProperty(key)) {
        delete priceVariantDictionary[this.state.selectedVariants[key]];
      }
    }
    if (
      this.state.filteredChildren.length &&
      priceVariantDictionary[vari] !== undefined &&
      (this.props.current_product.variant_keys.length > 1 ||
        this.props.current_product.parent !== null)
    ) {
      return `${vari} ${this.handleVariantPriceDiscount(
        priceVariantDictionary[vari]
      )}`;
    } else if (
      !this.state.filteredChildren.length &&
      priceVariantDictionary[vari] !== undefined &&
      (this.props.current_product.variant_keys.length === 1 ||
        this.props.current_product.parent !== null)
    ) {
      return `${vari} ${this.handleVariantPriceDiscount(
        priceVariantDictionary[vari]
      )}`;
    } else {
      return `${vari}`;
    }
  };
  render() {
    const { classes, themeColor, settings, language } = this.props;
    let variantsLoading = this.props.variantsLoading;
    let current_product = this.props.current_product;
    if (current_product.variant_values) current_product = this.findParent();
    let priceVariantDictionary = {};
    let updatedVariantDictionary = {};
    let variantDropdowns = null;


    if (this.props.current_product.parent && !this.state.editing) {
      variantDropdowns =
        this.props.language == "english" ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "auto 68px",
              alignItems: "center",
              height: 60,
            }}
          >
            <p
              key={Math.random() * 1000000}
              className="text-left m-0"
              style={{ paddingLeft: 21 }}
            >
              Selected{" "}
              {this.props.current_product.variant_values.map(
                (variantValue, index) => (
                  <>
                    <span>
                      {variantValue.variant_key.toLowerCase()}:{" "}
                      <span style={{ fontWeight: 600 }}>
                        {variantValue.variant_value}
                        {this.props.current_product.variant_values.length > 1 &&
                        index !==
                          this.props.current_product.variant_values.length - 1
                          ? ", "
                          : ""}
                      </span>
                    </span>
                  </>
                )
              )}
            </p>
            <Button
              style={{
                color: themeColor,
                marginRight: 15,
                textTransform: "none",
                fontWeight: "bold",
              }}
              onClick={() => this.setState({ editing: true })}
            >
              Change
            </Button>
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "auto 60px",
              direction: "rtl",
              alignItems: "center",
              height: 60,
            }}
          >
            <p
              key={Math.random() * 1000000}
              className="text-right m-0"
              style={{ paddingRight: 21 }}
            >
              {this.props.current_product.variant_values.map(
                (variantValue, index) => (
                  <>
                    <span>
                      {variantValue.variant_key_ar}:{" "}
                      <span style={{ fontWeight: 600 }}>
                        {variantValue.variant_value_ar}
                        {this.props.current_product.variant_values.length > 1 &&
                        index !==
                          this.props.current_product.variant_values.length - 1
                          ? "، "
                          : ""}
                      </span>
                    </span>
                  </>
                )
              )}
            </p>
            <Button
              style={{
                color: themeColor,
                marginLeft: 15,
                textTransform: "none",
                fontWeight: "bold",
              }}
              onClick={() => this.setState({ editing: true })}
            >
              تعديل
            </Button>
          </div>
        );
    } else {
      variantDropdowns = current_product.variant_keys.map((variant) => {
        let dropdownItems = [];
        if (!this.state.filteredChildren.length) {
          for (let i = 0; i < current_product.children.length; i++) {
            current_product.children[i].variant_values.forEach((value) => {
              if (value.variant_key == variant.variant_key) {
                if (
                  this.state.originalVariationsDictionary[value.variant_key]
                ) {
                  this.state.originalVariationsDictionary[
                    value.variant_key
                  ].push(
                    language == "english"
                      ? value.variant_value
                      : value.variant_value_ar
                  );
                } else {
                  this.state.originalVariationsDictionary[value.variant_key] = [
                    language == "english"
                      ? value.variant_value
                      : value.variant_value_ar,
                  ];
                }
              }
              priceVariantDictionary[
                language == "english"
                  ? value.variant_value
                  : value.variant_value_ar
              ] =
                current_product.variant_keys.length > 1
                  ? this.state.filteredChildren[i]
                  : current_product.children[i];
            });
          }
        } else {
          current_product.variant_keys.map((variant) => {
            for (let i = 0; i < this.state.filteredChildren.length; i++) {
              this.state.filteredChildren[i].variant_values.forEach((value) => {
                if (value.variant_key == variant.variant_key) {
                  if (updatedVariantDictionary[value.variant_key]) {
                    updatedVariantDictionary[value.variant_key].push(
                      language == "english"
                        ? value.variant_value
                        : value.variant_value_ar
                    );
                  } else {
                    updatedVariantDictionary[value.variant_key] = [
                      language == "english"
                        ? value.variant_value
                        : value.variant_value_ar,
                    ];
                  }
                }
                if (current_product.variant_keys.length === 1) {
                  for (let i = 0; i < current_product.children.length; i++) {
                    priceVariantDictionary[
                      language == "english"
                        ? current_product.children[i].variant_values[0]
                            .variant_value
                        : current_product.children[i].variant_values[0]
                            .variant_value_ar
                    ] = current_product.children[i];
                  }
                }
                priceVariantDictionary[
                  language == "english"
                    ? value.variant_value
                    : value.variant_value_ar
                ] =
                  current_product.variant_keys.length > 1
                    ? this.state.filteredChildren[i]
                    : current_product.children[i];
              });
            }
          });
        }
        dropdownItems = [
          ...new Set(
            this.state.originalVariationsDictionary[variant.variant_key]
          ),
        ]
          .filter((x) => !!x)
          .map((vari, indx) => {
            if (vari)
              return (
                <MenuItem
                  key={`${variant.variant_key} ${vari} ${indx}`}
                  value={vari}
                  style={{
                    color:
                      this.state.filteredChildren.length &&
                      !updatedVariantDictionary[variant.variant_key].includes(
                        vari
                      ) &&
                      variant.variant_key != this.state.lastKey
                        ? "gray"
                        : "black",
                  }}
                  classes={{
                    root: classes.selectMenuItem,
                  }}
                >
                  {/*{vari}*/}
                  <span
                    style={{
                      display: "inline-block",
                      direction: "ltr",
                    }}
                  >
                    {this.handleVariantPriceDisplay(
                      vari,
                      priceVariantDictionary
                    )}
                  </span>
                </MenuItem>
              );
          });
        return (
          <FormControl
            key={variant.variant_key}
            fullWidth
            className={classes.selectFormControl}
            id="Variants"
            name="Variants"
          >
            {this.props.current_product.parent &&
            this.props.language == "english"
              ? this.props.current_product.variant_values.map((vv) =>
                  vv.variant_key == variant.variant_key ? (
                    <p
                      key={`${variant.variant_key} ${vv.variant_value} `}
                      className="text-left mb-1 mt-1"
                      style={{ paddingLeft: 21 }}
                    >
                      Selected {vv.variant_key.toLowerCase()}:{" "}
                      <span style={{ fontWeight: 600 }}>
                        {vv.variant_value}
                      </span>
                    </p>
                  ) : null
                )
              : null}
            {this.props.current_product.parent &&
            this.props.language == "arabic"
              ? this.props.current_product.variant_values.map((vv) =>
                  vv.variant_key == variant.variant_key ? (
                    <p
                      key={`${variant.variant_key} ${vv.variant_value} `}
                      className="text-right mb-1 mt-1"
                      style={{ paddingRight: 21 }}
                    >
                      {vv.variant_key_ar} المختار:{" "}
                      <span style={{ fontWeight: 600 }}>
                        {vv.variant_value_ar}
                      </span>
                    </p>
                  ) : null
                )
              : null}
            <p
              className={"text-muted mb-0 ".concat(
                this.props.language == "english"
                  ? "text-left ml-4 "
                  : "text-right mr-4"
              )}
              style={{ fontSize: "1rem" }}
            >
              {this.props.language == "english"
                ? variant.variant_key
                : variant.variant_key_ar}
            </p>

            {!variantsLoading ? (
              current_product.variants_style === 0 ||
              current_product.variant_keys.length > 1 ? (
                <Select
                  key={Math.random() * 1000}
                  MenuProps={{
                    className: classes.selectMenu,
                  }}
                  classes={{
                    select: classes.select,
                  }}
                  className="mx-auto w-75"
                  defaultValue={-1}
                  ref="xx"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={this.state[variant.variant_key]}
                  onChange={(e, item) => {
                    if (item.props.style.color == "gray") {
                      this.resetVariants(e);
                    } else {
                      this.handleChange(e);
                    }
                  }}
                  name={variant.variant_key}
                >
                  <MenuItem
                    value={-1}
                    classes={{
                      root: classes.selectMenuItem,
                    }}
                    style={{ color: "black" }}
                  >
                    {this.props.language == "english"
                      ? `${this.props.current_product.parent ? "" : "Please"} ${
                          this.props.current_product.parent ? "S" : "s"
                        }elect ${
                          this.props.current_product.parent ? "another" : "a"
                        } ${variant.variant_key?.toLowerCase()}`
                      : `اختر ${variant.variant_key_ar} ${
                          this.props.current_product.parent ? "آخر" : ""
                        }`}
                  </MenuItem>
                  {dropdownItems}
                </Select>
              ) : (
                <div
                  style={{
                    minHeight: 140,
                    overflowX: "auto",
                    padding: "10px 0px",
                    direction: language === "arabic" ? "rtl" : "ltr",
                  }}
                  className="disable-scroll-bar"
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: `repeat(${dropdownItems.length}, auto)`,
                      columnGap: 20,
                      justifyContent: "center",
                      padding: "0px 20px",
                      width:
                        dropdownItems.length * 160 +
                        20 * (dropdownItems.length + 1),
                      direction: language === "arabic" ? "rtl" : "ltr",
                    }}
                  >
                    {dropdownItems.map((p) => {
                      const product = (current_product.children || []).find(
                        (child) => {
                          const vv = (child.variant_values || []).find(
                            (vvs) => vvs.variant_key === variant?.variant_key
                          );
                          const vvValue =
                            language === "english"
                              ? vv?.variant_value
                              : vv?.variant_value_ar;

                          return vvValue === p.props.value;
                        }
                      );

                      if (!product) return null;

                      let photo = product.photo;
                      if (!photo && product.gallery?.length)
                        photo =
                          product.gallery.find(
                            (g) => !!g.photo_medium || !!g.photo
                          )?.photo_medium ||
                          product.gallery.find(
                            (g) => !!g.photo_medium || !!g.photo
                          )?.photo;

                      const productName =
                        language === "english"
                          ? product.name
                          : product.ar_name || product.name;

                      const variantInfo = (product.variant_values || []).map(
                        (vvs) => {
                          const key =
                            language === "english"
                              ? vvs.variant_key
                              : vvs.variant_key_ar || vvs.variant_key;

                          const value =
                            language === "english"
                              ? vvs.variant_value
                              : vvs.variant_value_ar || vvs.variant_value;

                          return `${key}: ${value}`;
                        }
                      );

                      const fullVariantPriceText =
                        this.handleVariantPriceDisplay(
                          p.props.value,
                          priceVariantDictionary
                        );

                      const priceText =
                        typeof fullVariantPriceText === "string"
                          ? fullVariantPriceText.match(/\(([^)]+)\)/)?.[1] ||
                            fullVariantPriceText
                          : fullVariantPriceText;

                      return (
                        <div
                          key={p.props.value}
                          onClick={() => {
                            if (p.props.style.color == "gray") {
                              this.resetVariantsGrid(
                                variant?.variant_key,
                                p.props.value
                              );
                            } else {
                              this.handleChangeGrid(
                                variant?.variant_key,
                                p.props.value
                              );
                            }
                          }}
                          style={{
                            width: 160,
                            cursor: "pointer",
                            opacity: p.props.style.color == "gray" ? 0.6 : 1,
                          }}
                        >
                          <div
                            style={{
                              width: 160,
                              height: 120,
                              borderRadius: 6,
                              filter:
                                p.props.style.color == "gray"
                                  ? "grayscale(100%)"
                                  : "none",
                              background: !!photo
                                ? `url(${photo}) no-repeat center center`
                                : "#ccc",
                              backgroundSize: settings?.fit_images_to_div
                                ? "100% 100%"
                                : "cover",
                            }}
                          />

                          <p
                            className={"mt-2 mb-1 bold ".concat(
                              language === "english"
                                ? "text-left"
                                : "text-right"
                            )}
                            style={{
                              fontSize: 14,
                              lineHeight: "18px",
                              overflow: "hidden",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              minHeight: 36,
                            }}
                            title={productName}
                          >
                            {productName}
                          </p>

                          <div style={{ minHeight: 18 }}>
                            {variantInfo.map((line, idx) => (
                              <p
                                key={idx}
                                className={"mb-0 ".concat(
                                  language === "english"
                                    ? "text-left"
                                    : "text-right"
                                )}
                                style={{
                                  fontSize: 12,
                                  lineHeight: "16px",
                                  overflow: "hidden",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  minHeight: 32,
                                }}
                                title={line}
                              >
                                {line}
                              </p>
                            ))}
                          </div>

                          <p
                            className={"mt-2 mb-0 bold ".concat(
                              language === "english"
                                ? "text-left"
                                : "text-right"
                            )}
                            style={{ fontSize: 14 }}
                          >
                            {priceText}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )
            ) : (
              <div>
                <CircularProgress size={30} />
              </div>
            )}
          </FormControl>
        );
      });
    }
    if (
      Object.keys(this.state.selectedVariants).length ==
        Object.keys(this.state.originalVariationsDictionary).length &&
      Object.keys(this.state.originalVariationsDictionary).length != 0
    ) {
      if (!this.state.filteredChildren.length) {
        this.resetVariants();
        this.setState({ selectedVariants: new Object() });
      } else if (
        this.props.location.pathname !=
        `/product/${this.state.filteredChildren[0].category}/${this.state.filteredChildren[0].parent}/${this.state.filteredChildren[0].slug}`
      ) {
        this.props.setProduct(this.state.filteredChildren[0]);
        let history_state = undefined;
        if (
          this.props.location.state &&
          this.props.location.state.pending_items
        ) {
          history_state = { ...this.props.location.state };
        }
        this.props.history.replace(
          `/product/${this.state.filteredChildren[0].category}/${this.state.filteredChildren[0].parent}/${this.state.filteredChildren[0].slug}`,
          history_state
        );
      }
    }
    return (
      <div
        style={{
          backgroundColor: "white",
          paddingBottom: "20px !important",
        }}
        className="border mt-4"
      >
        {this.props.selectVariantCheck && (
          <div
            style={{
              display: "flex",
              marginTop: 10,
              marginLeft: language === "english" ? 21 : 0,
              marginRight: language === "english" ? 0 : 21,
              color: "red",
              font: 14,
              fontWeight: "bold",
              flexDirection: language === "english" ? "row" : "row-reverse",
            }}
          >
            <span>
              {language === "english" ? "Select Variant" : "اختار نوع"}
            </span>
          </div>
        )}
        {variantDropdowns}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    store: state.store.store,
    current_product: state.store.current_product,
    variantsLoading: state.store.variantsLoading,
    themeColor: state.store.store.settings.dark || "#0099cc",
    settings: state.store.store.settings,
    promotions: state.cart.discounts,
    coupon: state.cart.promos,
    usedComponents: state.store.used_components,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setProduct: (product) => dispatch(setProduct(product)),
    loadVariants: (productID) => dispatch(loadVariants(productID)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ProductVariants));
